import styled from 'styled-components';

import { priceVariants } from '../PlanTitleBlock';

import { PriceProps } from '.';

export const PriceValue = styled.div<Pick<PriceProps, 'variant'>>`
  margin-right: 5px;
  font-size: 32px;
  line-height: 39px;
  font-weight: 800;
  display: flex;
  align-items: baseline;
  ${({ variant }) => priceVariants[variant]}
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #919eaa;
  display: flex;
  align-items: end;
`;

export const BottomPriceBlock = styled.div`
  display: flex;
  &:last-of-type {
    margin-bottom: 70px;
  }
`;
